<template>
  <div>

    <div v-if="config" class="row">
      <div class="col-md-3">
        <div class="form-group">
          <input type="checkbox" id="showAuthor" v-model="config.showConfig.showAuthor">
          <label for="showAuthor">Show Author</label>
        </div>
      </div>
      <div class="col-md-3">
        <input type="checkbox" id="showCategories" v-model="config.showConfig.showCategories">
        <label for="showCategories">Show Categories</label>
      </div>
      <div class="col-md-3">
        <input type="checkbox" id="showThumbnail" v-model="config.showConfig.showThumbnail">
        <label for="showThumbnail">Show Thumbnail</label>
      </div>
      <div class="col-md-3">
        <input type="checkbox" id="showDate" v-model="config.showConfig.showDate">
        <label for="showDate">Show Date</label>
      </div>
      <div class="col-md-3">
        <input type="checkbox" id="showContent" v-model="config.showConfig.showContent">
        <label for="showContent">Show Content</label>
      </div>
      <div class="col-md-3">
        <input type="checkbox" id="showButton" v-model="config.showConfig.showButton">
        <label for="showButton">Show Button</label>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="">Select Article</label>
          <select v-model="selectedNew" class="form-control">
            <option v-for="article in allNews" :key="article.cryptID" :value="article.cryptID"> {{ article.title }} </option>
          </select>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="">Date Format</label>
          <select v-model="config.dateFormat" class="form-control">
            <option :value="'YYYY-MM-DD'">2020-01-01</option>
            <option :value="'DD/MM/YYYY'">01/01/2020</option>
          </select>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="">Button Position</label>
          <select v-model="config.buttonPosition" class="form-control">
            <option :value="'left'">Left</option>
            <option :value="'right'">Right</option>
          </select>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="">Read MoreText</label>
          <input class="form-control" type="text" v-model="config.readMoreText">
        </div>
      </div>
    </div>

    <button class="btn btn-primary" @click="getData">reload</button>
    <div class="row">
      <div class="col-md-12">
        <div class="float-right">
          <button class="btn btn-success float-right" @click="save">Save</button>
        </div>
      </div>
    </div>


  </div>
</template>

<script>

import _ from 'lodash';
import { getAllNews } from '../../../../../../js/services/editor/blog.js';

export default {
  name: 'FeaturedSettings',
  props: ['params'],
  data() {
    return {
      config: false,
      allNews: [],
      selectedNew: ''
    };
  },
  methods: {
    save() {
      let obj = { config: this.config, selectedNew: this.selectedNew };
      this.$emit('save', obj);
      this.$emit('close');
    },
    getData() {
      getAllNews()
        .then(({ data }) => {
          if (data.success) {
            this.allNews = data.data;
          }
        });
    }
  },
  mounted() {
    this.config = _.clone(this.params);
    // console.log(this.params)
    // this.selectedNew = this.params.article.id;
    this.getData();
  },
  watch: {
    params() {
      this.config = _.clone(this.params);
      typeof this.params.article !== 'undefined' ? this.selectedNew = this.params.article.id : console.log('sem erro');
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Blog/Settings/content/FeaturedSettings.vue